module.exports = __webpack_public_path__ + "img/curso_2_texto.ae51933e.png";